// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-code[data-v-88c32224]{font-size:6rem;font-weight:900}.error-code-message[data-v-88c32224]{font-size:1.5rem;font-weight:400;margin:10px 0}.link-voltar[data-v-88c32224]{font-size:1.2rem}", ""]);
// Exports
module.exports = exports;
